"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGamesPayload = void 0;
var game_api_1 = require("@l2p/game-api");
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var apps_shared_1 = require("@l2p/apps-shared");
var currencies_1 = require("../currencies");
var geo_1 = require("../geo");
var useGetGamesPayload = function (payload) {
    var _a, _b, _c, _d;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var geoData = (0, geo_1.useGeo)().data;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var isReady = (0, react_1.useMemo)(function () { return !!(Object.keys(breakpoints).length > 0 && geoData && currentCurrency); }, [breakpoints, geoData, currentCurrency]);
    var _e = (0, useQuery_1.useQuery)({
        payload: {
            page: payload === null || payload === void 0 ? void 0 : payload.page,
            limit: payload === null || payload === void 0 ? void 0 : payload.limit,
            filter: {
                categoryId: (_a = payload === null || payload === void 0 ? void 0 : payload.filter) === null || _a === void 0 ? void 0 : _a.categoryId,
                devices: [
                    breakpoints.mobile || breakpoints.tablet
                        ? game_api_1.GameDeviceTypeEnum.Mobile
                        : game_api_1.GameDeviceTypeEnum.Desktop,
                    game_api_1.GameDeviceTypeEnum.Universal,
                ],
                allowedCountries: ((_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode)
                    ? [(_c = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _c === void 0 ? void 0 : _c.countryCode]
                    : undefined,
                currencies: currentCurrency ? [currentCurrency] : undefined,
            },
        },
        path: keys_1.GAMES,
        canRender: !!((_d = payload.filter) === null || _d === void 0 ? void 0 : _d.categoryId) && isReady,
    }), data = _e.data, error = _e.error, isLoading = _e.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useGetGamesPayload = useGetGamesPayload;
